// extracted by mini-css-extract-plugin
export default {"message-box":"message_message-box__m8tbU","success":"message_success__Os9bn","error":"message_error__stUU4","warning":"message_warning__XMG6-"};